import Vue from 'vue';

Vue.component('countdown-thumb-slider', {
    props: ['countdownDate'],

    data() {
        return {
            shouldRender: false,
            seconds: 0,
            minutes: 0,
            hours: 0,
            days: 0,
            timeInterval: null,
        };
    },

    async mounted() {
        if (!this.countdownDate) {
            this.shouldRender = true;
            return;
        }

        this.calculateCountdown();
    },

    methods: {
        calculateCountdown() {
            const currentDate = new Date().getTime();
            const slideDate = new Date(this.countdownDate).getTime();
            if (currentDate > slideDate) return;

            this.shouldRender = true;
            this.timeInterval = setInterval(this.updateCountDown, 1000);
        },

        updateCountDown() {
            const total =
                Date.parse(this.countdownDate) - Date.parse(new Date());

            if (total <= 0) {
                this.shouldRender = false;
                clearInterval(this.timeInterval);
                return;
            }

            this.seconds = ('0' + Math.floor((total / 1000) % 60)).slice(-2);
            this.minutes = ('0' + Math.floor((total / 1000 / 60) % 60)).slice(
                -2,
            );
            this.hours = (
                '0' + Math.floor((total / (1000 * 60 * 60)) % 24)
            ).slice(-2);
            this.days = ('0' + Math.floor(total / (1000 * 60 * 60 * 24))).slice(
                -2,
            );
        },
    },

    beforeDestroy() {
        clearInterval(this.timeinterval);
    },
});
